import styled from 'styled-components';
import {color, font} from '../../../../theme';

export const HistorySource = styled.span`
  font-weight: 500;
  color: ${color.grey};
  font-size: 2.2rem;
  font-family: ${font.family.secondary};
`;
